module.exports = __webpack_public_path__ + "static/media/Grid5050.8de32328.png";